import React, { useState } from 'react';
import { 
    Box, 
    TextField, 
    Button, 
    Typography, 
    Avatar, 
    IconButton,
    Divider
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';

const UserProfile = () => {
    const [user, setUser] = useState({
        name: 'John Doe',
        email: 'john@example.com',
        phone: '123-456-7890',
        password: '********',
        avatar: 'https://via.placeholder.com/150'  // URL de la imagen del avatar
    });
    const [isEditing, setIsEditing] = useState(false);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setUser((prev) => ({ ...prev, [name]: value }));
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        // Lógica para guardar los cambios (por ejemplo, hacer una solicitud a la API)
        setIsEditing(false);
    };

    return (
        <Box sx={{ p: 3, maxWidth: 500, mx: 'auto' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Avatar src={user.avatar} sx={{ width: 80, height: 80, mr: 2 }} />
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h5">{user.name}</Typography>
                    <Typography variant="body2" color="textSecondary">{user.email}</Typography>
                </Box>
                {!isEditing && (
                    <IconButton onClick={handleEditClick} color="primary">
                        <EditIcon />
                    </IconButton>
                )}
            </Box>

            <Divider sx={{ mb: 3 }} />

            {isEditing ? (
                <>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Nombre completo"
                        name="name"
                        value={user.name}
                        onChange={handleInputChange}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Número de teléfono"
                        name="phone"
                        value={user.phone}
                        onChange={handleInputChange}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        type="password"
                        label="Contraseña"
                        name="password"
                        value={user.password}
                        onChange={handleInputChange}
                    />
                    <Button 
                        startIcon={<SaveIcon />} 
                        variant="contained" 
                        color="primary"
                        onClick={handleSaveClick}
                    >
                        Guardar Cambios
                    </Button>
                </>
            ) : (
                <>
                    <Typography variant="body1"><strong>Nombre:</strong> {user.name}</Typography>
                    <Typography variant="body1"><strong>Teléfono:</strong> {user.phone}</Typography>
                </>
            )}
        </Box>
    );
};

export default UserProfile;
